import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';
import { GET_ST_VEHICU } from '../../helpers/url_helper';

const useUpdateVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const apiBackendClient = new ApiBackendClient();

    const updateVehiculo = async (PATENT, datosVehiculo) => {
        setLoading(true);
        setError(null);
        try {
            // Transform data to match backend expectations
            const transformedData = {
                MARCAS: datosVehiculo.marca?.value || null,
                MODELO: datosVehiculo.modelo?.value || null,
                ANOFAB: datosVehiculo.ano ? parseInt(datosVehiculo.ano, 10) : null,
                CCOLOR: datosVehiculo.color?.value || null,
                NMOTOR: datosVehiculo.motor || null,
                NCHASI: datosVehiculo.chasis || null,
                NROVIN: datosVehiculo.vin || null,
                TRACCI: datosVehiculo.tipoTraccion?.value || null,
                TRASMI: datosVehiculo.tipoTransmision?.value || null,
                COMBUS: datosVehiculo.tipoCombustible?.value || null,
                CLIENT: datosVehiculo.rut || null
            };
            console.log('Datos a actualizar:', transformedData);
            const queryParams = `?tenantId=${tenantId}&empresa=${empresa}&departamento=${departamento}`;
            const response = await apiBackendClient.put(`${GET_ST_VEHICU}/${empresa}/${PATENT}${queryParams}`, {
                vehicleData: transformedData,
                usuario: userInfo?.name
            });
            console.log('Response from API:', response);
            if (response) {
                console.log('Vehículo actualizado con éxito');
                return { success: true };
            } else {
                throw new Error(response.message || 'Error al actualizar el vehículo');
            }
        } catch (err) {
            const errorMessage = `Failed to update vehiculo: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { updateVehiculo, loading, error };
};

export default useUpdateVehiculo;